export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const dataUrl = reader.result as string;
      resolve(dataUrl);
    };

    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}